import React, { useState } from "react";
import { SendOutlined, UserOutlined, RobotOutlined } from "@ant-design/icons";

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const predefinedResponses = {
    hello: "Hi there! How can I help you?",
    help: "Sure! Let me know what you need assistance with.",
    bye: "Goodbye! Have a great day!",
  };

  const handleSendMessage = () => {
    if (input.trim() === "") return;

    const userMessage = { text: input, sender: "user" };
    setMessages([...messages, userMessage]);

    setTimeout(() => {
      const botResponse = predefinedResponses[input.toLowerCase()] || "I'm not sure how to respond to that.";
      setMessages((prevMessages) => [...prevMessages, { text: botResponse, sender: "bot" }]);
    }, 1000);

    setInput("");
  };

  return (
    <div style={styles.chatContainer}>
      <div style={styles.chatBox}>
        {messages.map((msg, index) => (
          <div key={index} style={msg.sender === "user" ? styles.userMessage : styles.botMessage}>
            {msg.sender === "user" ? <UserOutlined style={styles.icon} /> : <RobotOutlined style={styles.icon} />}
            <span>{msg.text}</span>
          </div>
        ))}
      </div>
      <div style={styles.inputContainer}>
        <input
          type="text"
          placeholder="Type a message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={styles.inputField}
          onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
        />
        <button onClick={handleSendMessage} style={styles.sendButton}>
          <SendOutlined />
        </button>
      </div>
    </div>
  );
};

const styles = {
  chatContainer: {
    width: "300px",
    margin: "auto",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#fff",
  },
  chatBox: {
    maxHeight: "400px",
    overflowY: "auto",
    padding: "20px",
    background: "#f4f4f4",
  },
  userMessage: {
    textAlign: "right",
    padding: "10px",
    margin: "5px",
    background: "#063970",
    color: "#fff",
    borderRadius: "10px",
    display: "inline-block",
  },
  botMessage: {
    textAlign: "left",
    padding: "10px",
    margin: "5px",
    background: "#ec9949",
    color: "#fff",
    borderRadius: "10px",
    display: "inline-block",
  },
  inputContainer: {
    display: "flex",
    padding: "10px",
    background: "#fff",
    borderTop: "1px solid #ddd",
  },
  inputField: {
    flex: 1,
    padding: "10px",
    border: "none",
    outline: "none",
    fontSize: "16px",
  },
  sendButton: {
    padding: "10px 15px",
    background: "#063970",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
  },
  icon: {
    marginRight: "5px",
  },
};

export default Chatbot;
